import { render, staticRenderFns } from "./compElRadioGroup.vue?vue&type=template&id=2ba80f96&scoped=true&"
import script from "./compElRadioGroup.vue?vue&type=script&lang=js&"
export * from "./compElRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./compElRadioGroup.vue?vue&type=style&index=0&id=2ba80f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba80f96",
  null
  
)

export default component.exports